import typicalPlan from '../assets/images/floor_plan/Typical_Plan.PNG'
import amenitiesImg from '../assets/images/floor_plan/amenitiesImg.PNG';
import flat01 from '../assets/images/floor_plan/01_1bhk.PNG';
import flat02 from '../assets/images/floor_plan/02_2bhk.PNG';
import flat03 from '../assets/images/floor_plan/03_2bhk.PNG';
import flat04 from '../assets/images/floor_plan/04_2bhk.PNG';
import flat05 from '../assets/images/floor_plan/05_1bhk.PNG';
import jodi_plan from '../assets/images/floor_plan/jodi_plan.png';

import '../assets/css/floorplan.css';
import { useState } from 'react';

const FloorPlan = () => {
    const [isZoomed, setIsZoomed] = useState(false);

    const [activeFilterIndex, setActiveFilterIndex] = useState(0);
    const [imageSrc, setImageSrc] = useState(amenitiesImg);


    const changeFloorPlan = (floorPlan, index) => {
        setActiveFilterIndex(index);
        setImageSrc(floorPlan);
    }

    return (
        <div className="floorplan_container">
            <div className="w-100 d-flex justify-content-sm-between h-100">
                <div className="left_side_container grey-bg">
                    <img alt="floor_plan_image" src={imageSrc} style={{ maxWidth: "100%" }} className={`zoomable-image ${isZoomed ? "zoomed" : ""}`} onClick={() => setIsZoomed(!isZoomed)} />
                </div>

                <div className="right_side_container">
                    <div className='floor_plan_button-conainer'>
                        <button className="floor_plan_lable">Floor Plans</button>
                        <button onClick={() => { changeFloorPlan(amenitiesImg, 0) }} className={`${activeFilterIndex === 0 ? 'active' : ''} `}>Amenities Floor Plan</button>
                        <button onClick={() => { changeFloorPlan(typicalPlan, 1) }} className={`${activeFilterIndex === 1 ? 'active' : ''} `}>Typical Floor Plan</button>
                        <button onClick={() => { changeFloorPlan(flat01, 2) }} className={`${activeFilterIndex === 2 ? 'active' : ''} `}>1 BHK (453 SQFT)</button>
                        <button onClick={() => { changeFloorPlan(flat05, 6) }} className={`${activeFilterIndex === 6 ? 'active' : ''} `}>1 BHK (435 SQFT)</button>
                        <button onClick={() => { changeFloorPlan(flat02, 3) }} className={`${activeFilterIndex === 3 ? 'active' : ''} `}>2 BHK (638 SQFT)</button>
                        <button onClick={() => { changeFloorPlan(flat03, 4) }} className={`${activeFilterIndex === 4 ? 'active' : ''} `}>2 BHK (641 SQFT)</button>
                        <button onClick={() => { changeFloorPlan(flat04, 5) }} className={`${activeFilterIndex === 5 ? 'active' : ''} `}>2 BHK (617 SQFT)</button>
                        <button onClick={() => { changeFloorPlan(jodi_plan, 7) }} className={`${activeFilterIndex === 7 ? 'active' : ''} `}>JODI (1091 SQFT)</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FloorPlan;